import React, {Fragment} from "react";
import {useAuth0} from "../react-auth0-wrapper";

const Profile = () => {
    const {loading, user} = useAuth0();

    if (loading || !user) {
        return (
            <div className="pageloader is-active">
                <span className="title">Loading Profile</span>
            </div>

        );
    }

    return (
        <Fragment>
            <img src={user.picture} alt="Profile"/>

            <h2>{user.name}</h2>
            <p>{user.email}</p>
            <code>{JSON.stringify(user, null, 2)}</code>
        </Fragment>
    );
};

export default Profile;